var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      class: _setup.props.errors.is
        ? "cabin__errors cabin-errors"
        : "cabin__checked cabin-checked",
    },
    [
      _setup.props.errors.is
        ? [
            _c("div", { staticClass: "cabin-error" }, [
              _c(
                "div",
                { staticClass: "cabin-error__icon" },
                [_c(_setup.vWarning, { staticClass: "icon vicon-orange" })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cabin-error__text" }, [
                _vm._v(_vm._s(_setup.props.errors.texts.join("; "))),
              ]),
            ]),
          ]
        : [
            _c(
              "div",
              { staticClass: "cabin-checked__icon" },
              [_c(_setup.checked(), { tag: "component", staticClass: "icon" })],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cabin-checked__text" }, [
              _vm._v("Заполнено верно"),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }